export const clients = {
  table: {
    id: 'ID',
    name: '工程',
    lastPingAt: '最終信号',
    isOffline: '状態',
    offline: 'オフライン',
    online: 'オンライン',
    detailDevice: '詳細デバイス',
    date: '日付',
    status: '状態',
  },
  pageHeader: {
    title: 'デバイスリスト',
    titleDetail: 'デバイスの詳細',
    titleListDetailError: '設備稼働履歴',
  },
}
